export type AdminSaveKind = 'configuration' | 'field' | 'payer';

export function formatAdminSaveErrorMessage(failedKinds: AdminSaveKind[]): string | undefined {
  const uniqueKinds = new Set(failedKinds);
  if (uniqueKinds.size === 0) return undefined;
  if (uniqueKinds.size === 1) {
    if (uniqueKinds.has('payer')) return 'Payer changes could not be saved. Review and retry.';
    if (uniqueKinds.has('configuration')) {
      return 'Configuration changes could not be saved. Review and retry.';
    }
    return 'Field changes could not be saved. Review and retry.';
  }

  const labels = [
    uniqueKinds.has('configuration') ? 'configuration' : null,
    uniqueKinds.has('field') ? 'field' : null,
    uniqueKinds.has('payer') ? 'payer' : null,
  ].filter((label): label is string => label !== null);
  labels[0] = `${labels[0][0].toUpperCase()}${labels[0].slice(1)}`;
  const formattedLabels =
    labels.length === 2
      ? labels.join(' and ')
      : `${labels.slice(0, -1).join(', ')}, and ${labels.at(-1)}`;
  return `${formattedLabels} changes could not be saved. Review and retry.`;
}
